/**
 * Check if passed value is type of Array.
 *
 * @param {unknown[]} value Value to check.
 * @returns {boolean}
 */
export function isArray(value) {
    if (value === null || typeof value === 'undefined') {
        return false;
    }
    const length = value.length;
    const isValidLength = typeof length === 'number' && length > -1 && length % 1 === 0;
    return typeof value !== 'function' && typeof value !== 'string' && isValidLength;
}
